import DocumentManagement from "../../assets/images/sidebar/document_management.svg";

const documentManagementModule = {
  name: "Document Management",
  key: "document_management",
  imgSrc: DocumentManagement,
  submodules: [
    {
      name: "Document Dashboard",
      key: "document_dashboard",
      defaultExpanded: false,
      features: [
        {
          key: "document_dashboard",
          name: "Document Dashboard",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_client_documents_list",
              name: "View Client Documents List",
              defaultEnabled: true,
              description: "Show list of client-uploaded documents"
            },
            {
              key: "access_client_documents_list",
              name: "Access Client Documents List",
              defaultEnabled: false,
              description: "Full access to client document list"
            }
          ]
        }
      ]
    }
  ]
};

export default documentManagementModule;
